"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _javascriptStyleHelpers = require("@uie/javascript-style-helpers");
var _theme = require("@vds/theme");
var _templateObject;
var propTypes = exports.propTypes = {
  /**
   * @ignore
   */
  bodyConfig: _propTypes["default"].object,
  /**
   * @ignore
   */
  typographyConfig: _propTypes["default"].object,
  /**
   * @ignore
   */
  children: _propTypes["default"].node.isRequired,
  /**
   * @ignore
   */
  disabled: _propTypes["default"].bool,
  /**
   * @ignore
   */
  inverted: _propTypes["default"].bool,
  /**
   * @ignore
   */
  labelMargin: _propTypes["default"].number,
  /**
   * @ignore
   */
  labelMaxWidth: _propTypes["default"].number,
  /**
   * @ignore
   */
  labelMinWidth: _propTypes["default"].number,
  /**
   * @ignore
   */
  lastChild: _propTypes["default"].bool,
  /**
   * @ignore
   */
  theme: _propTypes["default"].object,
  /**
   * @ignore
   */
  typescale: _propTypes["default"].string,
  /**
   * @ignore
   */
  focusSize: _propTypes["default"].func,
  /**
   * @ignore
   */
  colorConfig: _propTypes["default"].object
};
var defaultProps = {
  lastChild: false,
  inverted: false
};

/**
 * @ignore
 */
var StyledLabel = /*#__PURE__*/_styledComponents["default"].label.withConfig({
  displayName: "StyledLabel",
  componentId: "sc-15g6ova-0"
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  ", ";\n  color: ", ";\n  cursor: ", ";\n  display: inline-flex;\n  flex-basis: 100%;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow: ", ";\n  position: relative;\n  text-align: center;\n  -webkit-hyphens: auto;\n  -moz-hyphens: auto;\n  -ms-hyphens: auto;\n  -o-hyphens: auto;\n  word-break: break-word;\n  hyphens: auto;\n"])), function (_ref) {
  var bodyConfig = _ref.bodyConfig,
    getFontStyles = _ref.getFontStyles,
    typescale = _ref.typescale;
  return getFontStyles(bodyConfig, typescale);
}, function (_ref2) {
  var colorConfig = _ref2.colorConfig,
    inverted = _ref2.inverted;
  return inverted ? colorConfig.white : colorConfig.black;
}, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? "default" : "pointer";
}, function (_ref4) {
  var focusSize = _ref4.focusSize;
  return focusSize ? "visible" : "hidden";
});
var ColorLabel = function ColorLabel(props) {
  var bodyConfig = props.bodyConfig,
    disabled = props.disabled,
    labelMargin = props.labelMargin,
    labelMaxWidth = props.labelMaxWidth,
    labelMinWidth = props.labelMinWidth,
    theme = props.theme,
    typescaleProp = props.typescale,
    typographyConfig = props.typographyConfig,
    colorConfig = props.colorConfig,
    inverted = props.inverted;
  var typescale = typescaleProp;
  if (!typescaleProp) typescale = typographyConfig.getTypescale();
  function _getFontStack(bodyConfig, typescale, typographyConfig) {
    return bodyConfig.getStyles(typescale, "desktop", "small");
  }
  function _getFontStyles() {
    var fontStack = _getFontStack(bodyConfig, typescale, typographyConfig);
    return "\n      font-family: ".concat(fontStack.fontFamily, ";\n      font-size: ").concat((0, _javascriptStyleHelpers.calculateRem)(fontStack.fontSize), ";\n      line-height: ").concat((0, _javascriptStyleHelpers.calculateRem)(fontStack.lineHeight), ";\n    ");
  }
  return /*#__PURE__*/_react["default"].createElement(StyledLabel, (0, _extends2["default"])({
    bodyConfig: bodyConfig,
    disabled: disabled,
    getFontStyles: _getFontStyles,
    theme: theme,
    typescale: typescale,
    colorConfig: colorConfig,
    inverted: inverted
  }, props));
};
ColorLabel.propTypes = propTypes;
ColorLabel.defaultProps = defaultProps;
var _default = exports["default"] = ColorLabel;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/inputs/dist/cjs/components/RadioSwatch/ColorLabel.js
// module id = 1456
// module chunks = 0